var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPermissionsEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.875 7.625V9.5H15.125V7.625C15.125 5.89844 13.7266 4.5 12 4.5C10.2734 4.5 8.875 5.89844 8.875 7.625ZM6.375 9.5V7.625C6.375 4.51953 8.89453 2 12 2C15.1055 2 17.625 4.51953 17.625 7.625V9.5H18.25C19.6289 9.5 20.75 10.6211 20.75 12V19.5C20.75 20.8789 19.6289 22 18.25 22H5.75C4.37109 22 3.25 20.8789 3.25 19.5V12C3.25 10.6211 4.37109 9.5 5.75 9.5H6.375Z",
    fill: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionsEnabled);
export default __webpack_public_path__ + "static/media/PermissionsEnabled.4cfe925e7479aa5e8ab6dc5a0aa52ede.svg";
export { ForwardRef as ReactComponent };